import { GlobeAltIcon } from '@heroicons/react/24/outline';

import {
  Assets as AssetsIcon,
  Seeds as SeedsIcon,
  Vulnerabilities as VulnerabilitiesIcon,
} from '@/components/chariot-ui';

interface BulkEntityIconCircleProps {
  resource: string;
}

/**
 * Renders a colored circle with entity icon. Mirrors GlobalDownload.tsx
 * EntityIconCircle but accepts string resource names.
 */
export function BulkEntityIconCircle({ resource }: BulkEntityIconCircleProps) {
  const iconClass = 'size-4 shrink-0';

  const icon = (() => {
    switch (resource) {
      case 'asset':
        return <AssetsIcon className={`${iconClass} stroke-white`} />;
      case 'seed':
        return <SeedsIcon className={`${iconClass} fill-white`} />;
      case 'risk':
        return <VulnerabilitiesIcon className={`${iconClass} fill-white`} />;
      case 'technology':
        return <GlobeAltIcon className={`${iconClass} stroke-white`} />;
      default:
        return <GlobeAltIcon className={`${iconClass} stroke-white`} />;
    }
  })();

  return (
    <div className="bg-chariot-brand-primary flex size-8 shrink-0 items-center justify-center rounded-full">
      {icon}
    </div>
  );
}
